import React from 'react'

import { AtsLockContext } from 'components/common/AtsLock'

import { useTooltip } from 'hooks'

export const useButton = () => {
  const { owner } = React.useContext(AtsLockContext) ?? {}

  const {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  } = useTooltip()

  return {
    state: {
      arrowRef,
      arrowStyle,
      floating,
      floatingStyle,
      owner,
      reference,
      hasArrow,
      isToggled,
    },
    handlers: {
      handleBlur,
      handleFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleTouchEnd,
      handleTouchStart,
    },
  }
}
